export enum SMSTemplateType {
  CONFIRMATION = 'confirmation',
  REMINDER = 'reminder',
  PICKUP = 'pickup',
}

export const SMS_TEMPLATE_TYPES = Object.values(SMSTemplateType);
